import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    updateUserLoading: false,

    firstName: "",
    lastName: "",
    mail: "",

    active: false,

    updateModal: false,

    successMessage: null,
    updateUserErrorMessage: null,
    errorMessage: null,

    changePasswordModal: false,
    changePasswordErrorMessage: undefined,

    showHubspotChat: false,
};

const platformUserSlice = createSlice({
    name: "PlatformUser",
    initialState,

    reducers: {
        getUserRequest(state) {
            state.loading = true;
            state.errorMessage = null;
        },
        getUserSuccess(state, action) {
            state.loading = false;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.mail = action.payload.mail;
            state.active = action.payload.active;
            state.emailVerificationEnabled = action.payload.emailVerificationEnabled;
            state.authProvider = action.payload.authProvider;
            state.mfaEnabled = action.payload.mfaEnabled;
        },
        getUserFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
        },
        updateUserRequest(state) {
            state.updateUserLoading = true;
            state.updateUserErrorMessage = null;
            state.successMessage = null;
        },
        updateUserSuccess(state, action) {
            state.updateUserLoading = false;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.mail = action.payload.mail;
            state.active = action.payload.active;
            state.emailVerificationEnabled = action.payload.emailVerificationEnabled;
        },
        updateUserFailure(state, action) {
            state.updateUserLoading = false;
            state.updateUserErrorMessage = action.payload;
        },

        switchOrganizationRequest(state) {
            state.switchOrganizationLoading = true;
        },
        switchOrganizationSuccess(state) {
            state.switchOrganizationLoading = false;
        },
        switchOrganizationFailure(state, action) {
            state.switchOrganizationLoading = false;
            state.errorMessage = action.payload;
        },

        toggleUpdateModal(state) {
            state.updateModal = !state.updateModal;
            state.updateUserErrorMessage = null;
        },
        clearUpdateMessage(state) {
            state.loading = false;
            state.updateModal = false;
            state.updateUserErrorMessage = null;
            state.successMessage = null;
        },
        toggleHubspotChat(state) {
            state.showHubspotChat = !state.showHubspotChat;
        },
        deleteUserRequest(state) {
            state.errorMessage = null;
            state.deletionLoading = true;
        },
        deleteUserSuccess(state) {
            state.deleteModal = false;
            state.errorMessage = null;
            state.deletionLoading = false;
        },
        deleteUserFailure(state, action) {
            state.deleteModal = true;
            state.errorMessage = action.payload;
            state.deletionLoading = false;
        },

        updatePasswordRequest(state) {
            state.changePasswordLoading = true;
            state.changePasswordErrorMessage = null;
        },
        updatePasswordSuccess(state) {
            state.changePasswordLoading = false;
            state.changePasswordModal = false;
        },
        updatePasswordFailure(state, action) {
            state.changePasswordLoading = false;
            state.changePasswordErrorMessage = action.payload;
        },
        toggleChangePasswordModal(state) {
            state.changePasswordModal = !state.changePasswordModal;
            state.changePasswordErrorMessage = null;
        },
        clearChangePasswordMessages(state) {
            state.changePasswordErrorMessage = null;
        },
    },
});

export default platformUserSlice;
